module.exports = __webpack_public_path__ + "img/pipe_top.770214db.svg";